import { AlertCircle } from "lucide-react";

import { Centered } from "@/components/ui/container";
import { Text } from "@/components/ui/text";

export function NotFound() {
  return (
    <Centered className="h-screen w-full bg-background">
      <Text size="lg" bold className="flex items-center gap-2">
        <AlertCircle className="size-6" />
        Page not found
      </Text>
    </Centered>
  );
}
